/* eslint-disable max-len */
import * as React from "react";
import { Button } from "reactstrap";


import * as constants from "../constants/index"; 

interface NoticeProps {
    onAction: () => void;
}

class NoticeScreen extends React.Component<NoticeProps, {}> {
    constructor(props: any) {
        super(props);

        this.onAcceptNotice = this.onAcceptNotice.bind(this);
    }

    
    onAcceptNotice() {
        this.props.onAction();
    } 
    render() {
        return ( 
            <React.Fragment>
                <div  className="grid-container mobile-padding-x-neg-3">
                    <main id="main-content" className="grid-container overflow-hidden bg-white">
                        <div className="padding-top-1px tablet:padding-y-0 grid-row margin-x-neg-1 tablet:margin-x-0"> 
                            <div className="grid-col-11 order-1 tablet:order-2 tablet:margin-x-2 margin-bottom-2 tablet:margin-y-2">
                                <br></br>
                                <h1 className="maintitle">
                    Is My Account Fully Insured?
                                </h1>
                
                                <h3>MONITORING STATEMENT</h3>
                                <span  >  
                                    {constants.NOTICE_LINE1}
                                    {/* this is a Federal Deposit Insurance Corporation (FDIC) computer system. This computer system may be
                        monitored by the FDIC for lawful purposes. All information (including personal and confidential)
                        placed on or sent over this system may be examined, recorded or copied, used or disclosed by the
                        FDIC for authorized purposes. Any information collected during monitoring may be used for purposes
                        of any administrative, civil or criminal action or proceeding. */}
                                    <br /> 
                                </span>

                                <h3 className="subheader">PRIVACY ACT STATEMENT</h3>
                                <span>  
                                    {/* the Federal Deposit Insurance Act (12 U.S.C. §§ 1819, 1821, and 1822) and 12 C.F.R. Part 330 authorize the collection of this information.  
                        The purpose for collecting this information is to support the determination of deposit insurance coverage and/or the payment of deposit insurance 
                        on deposits of the closed financial institution.  Furnishing this information is voluntary but failure to provide the requested information in whole or 
                        in part may delay or prevent the determination of deposit insurance coverage and/or the payment of deposit insurance on deposits of the closed financial 
                        institution.  The information provided by individuals is protected by the Privacy Act, 5 U.S.C. 552a.  The information you provide may be provided to 
                        appropriate Federal, state, local or foreign law enforcement authorities; to a court, administrative tribunal, or a party in litigation; to contractors, 
                        agents and other third parties as authorized by law, and in accordance with any of the other routine uses described in the FDIC Unclaimed Deposit Account 
                        Records (FDIC-30-64-0024) System of Records.  A complete copy of this System of Records is available at <a href="http://www.fdic.gov/about/privacy">www.fdic.gov/about/privacy</a>.   If you have questions or 
                        concerns about the collection or use of the information, you may contact the FDIC’s Chief Privacy Officer at <a href='mailto:Privacy@fdic.gov'>Privacy@fdic.gov</a>.
                        <br></br> */}
                        The Federal Deposit Insurance Act (12 U.S.C. §§1819 and 1821) and Executive Order 9397, as amended, authorize the collection of this information. 
                        The FDIC will use the information to help individuals with accounts at a failed institution determine the insurance status of their accounts. 
                        Submitting this information to the FDIC is voluntary. Failure, however, to submit all of the information requested could result in your inability 
                        to determine the insurance status of their accounts at a failed financial institution via this web application. The information provided by individuals
                        is protected by the Privacy Act, 5 USC §552a. The information may be furnished to appropriate Federal, state, local or foreign law enforcement authorities; 
                        to a court, administrative tribunal, or a party in litigation; to contractors, agents and other third parties as authorized by law or used according to 
                        any of the other routine uses described in the FDIC Insured Financial Institution Liquidation Records (FDIC-30-64-0013) System of Records. 
                        A complete copy of this System of Records is available at  <a href="http://www.fdic.gov/about/privacy">www.fdic.gov/about/privacy</a>.If you have questions or concerns about the collection or use of 
                        the information, you may contact the FDIC's Chief Privacy Officer at <a href='mailto:Privacy@fdic.gov'>Privacy@fdic.gov</a>.

                                </span> 
                                <br></br>
                                <br></br>
                    
                            </div> 
               
                        </div>
                    </main>
                    <div  className="grid-container mobile-padding-x-neg-2">
                        <div  className="ds-l-row ds-u-justify-content--center">
                            <div className="col-sm-150 align-self-center">
                                <div>                <span>
                                    <Button color="blue" className="usa-button margin-bottom-3 margin-x-auto text-uppercase usa-button--primary" onClick={this.onAcceptNotice} >{"Continue"}</Button>  
                                </span> 
                                </div>
                                <div>
                    
                                    <br></br>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }
} 
export default NoticeScreen;